import { Injectable } from '@angular/core';
import { BehaviorSubject, take } from 'rxjs';
import { ApiService } from '../api/api.service';
import { ExternalDataService } from '../external-data/external-data.service';
import { ECommercePaymentRequest } from '../api/api.models';
import { ErrorService } from '../error/error.service';

export interface DoPaymentParameters {
  epan: string;
  expDateMonth: string;
  expDateYear: string;
  cardHolderName: string;
  cvv2: string;
  register: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class PaymentService {
  public $isProcessingOrProcessed = new BehaviorSubject(false);

  constructor(
    private apiService: ApiService,
    private externalDataService: ExternalDataService,
    private errorService: ErrorService
  ) {}

  doPayment(params: DoPaymentParameters) {
    this.$isProcessingOrProcessed.next(true);
    this.externalDataService.$data.pipe(take(1)).subscribe(externalData => {
      const paymentData: ECommercePaymentRequest = {
        epan: params.epan,
        expiryDate: params.expDateMonth + "/" + params.expDateYear,
        cardholderName: params.cardHolderName,
        cvv2: params.cvv2,
        register: params.register,
        terminalId: externalData.terminalId,
        clientId: +externalData.clientId,
        amount: +externalData.amount,
        currencyCodeNum: +externalData.currencyCodeNum,
        companyId: +externalData.companyId,
        datetime: externalData.datetime,
        hmacFields: externalData.hmacFields,
        hmac: externalData.hmac,
      }

      this.apiService.doEcommercePayment(externalData.transactionId, paymentData).subscribe({
        next: (response) => {
          this.externalDataService.sendParentSuccessResponse(response);
        },
        error: (error) => {
          this.errorService.handleApiError(error);
          this.$isProcessingOrProcessed.next(false);
        }
      })
    })
  }
}
